var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5368 21C4.71579 21 0 16.2842 0 10.5368C0 4.71579 4.71579 0 10.5368 0C16.2842 0 21 4.71579 21 10.5368C21 16.2842 16.2842 21 10.5368 21ZM14.5895 10.0211H11.2V4.86316C11.2 3.38947 9.06316 3.38947 9.06316 4.86316V11.0526C9.06316 11.7158 9.50526 12.1579 10.0947 12.1579H14.5895C15.9895 12.1579 15.9895 10.0211 14.5895 10.0211Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.fe274016b656d54155966a2348d9050e.svg";
export { ForwardRef as ReactComponent };